import debounce from "../debounce";

$(function() {
  const $container = $('#read-this-article-banner-container-hero')
  const $banner = $('#read-this-article-banner-container-hero .read-this-article-immersive')

  const calculateStickyClasses = function() {
    // resolve height bug with iOS - https://stackoverflow.com/a/22620066/985909
    const windowHeight = window.innerHeight ? window.innerHeight : $(window).height()

    const topOfFooter = $container.position().top
    const currentScrollPosition = windowHeight + $(window).scrollTop()

    if (currentScrollPosition - $banner.outerHeight() > topOfFooter) {
      $banner.removeClass('sticky')
    } else {
      $banner.addClass('sticky')
    }
  }

  const debouncedCalculateStickyClasses = debounce(calculateStickyClasses, 25)

  if ($container.length) {
    calculateStickyClasses()
    $(window).scroll(calculateStickyClasses)
    $(window).resize(debouncedCalculateStickyClasses)
  }
})
